// JsFromRoutes CacheKey cd4f367a6726d76c68fe80bf04deb4ea
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@consumer/services/api'

export default {
  show: /* #__PURE__ */ definePathHelper('get', '/update-contact/:token'),
  update: /* #__PURE__ */ definePathHelper('patch', '/update-contact/:token'),
  preferences: /* #__PURE__ */ definePathHelper('get', '/update-contact/:token/preferences'),
  updatePreferences: /* #__PURE__ */ definePathHelper('patch', '/update-contact/:token/preferences'),
}
